const PREVIEW_CUSTOMIZE_SLUG = '/preview-customize';

export default PREVIEW_CUSTOMIZE_SLUG;
